import { render, staticRenderFns } from "./NewsStories.vue?vue&type=template&id=32e5044c&scoped=true"
import script from "./NewsStories.vue?vue&type=script&lang=js"
export * from "./NewsStories.vue?vue&type=script&lang=js"
import style0 from "./NewsStories.vue?vue&type=style&index=0&id=32e5044c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e5044c",
  null
  
)

export default component.exports